import React from 'react';
import MarginGuardHeld from '../components/MarginGuardHeld';

// FIRST-RELEASE LEGACY UI PRESERVED, INACTIVE LINE COMMENTS ONLY
// Original source: 34b99b9f6e8d7980f6ee89d06ad8ba9515129386:frontend/src/pages/PromiseWizardPage.js
// Original UTF-8 SHA256: 56c96cd6dd3cc2e809f5175df69de1536259b9f88eddfcd2bb50e00f6f97cf4d
// Held legacy UI cannot fetch, render historical scores, or execute a fallback.
// Restore only after verified tenant/staff access, current data, denial tests,
// independent review and explicit owner approval of restoration.
// BEGIN ORIGINAL SOURCE
// /**
//  * Promise Wizard - Setup Flow for Margin Guard
//  * 
//  * Step-by-step configuration wizard:
//  * 1. Promise Policy (standard/expedited delivery windows)
//  * 2. Node Mapping (fulfillment locations)
//  * 3. Cancellation Window (buyer remorse threshold)
//  * 4. Alerts Configuration
//  */
// 
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Shield,
//   ChevronLeft,
//   ChevronRight,
//   Check,
//   Clock,
//   Layers,
//   AlertTriangle,
//   Bell,
//   Save,
//   RefreshCw,
//   Settings,
//   MapPin,
//   Truck,
//   Building2,
//   Package
// } from 'lucide-react';
// import { toast } from 'sonner';
// 
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// 
// // Step indicator component
// const StepIndicator = ({ steps, currentStep }) => {
//   return (
//     <div className="flex items-center justify-center gap-2 mb-8">
//       {steps.map((step, index) => (
//         <React.Fragment key={step.id}>
//           <div className="flex items-center gap-2">
//             <div
//               className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${
//                 index < currentStep
//                   ? 'bg-emerald-600 text-white'
//                   : index === currentStep
//                   ? 'bg-emerald-600 text-white'
//                   : 'bg-slate-800 text-slate-400'
//               }`}
//             >
//               {index < currentStep ? <Check className="w-4 h-4" /> : index + 1}
//             </div>
//             <span
//               className={`text-sm font-medium hidden md:block ${
//                 index <= currentStep ? 'text-slate-200' : 'text-slate-500'
//               }`}
//             >
//               {step.title}
//             </span>
//           </div>
//           {index < steps.length - 1 && (
//             <div
//               className={`w-12 h-0.5 ${
//                 index < currentStep ? 'bg-emerald-600' : 'bg-slate-700'
//               }`}
//             />
//           )}
//         </React.Fragment>
//       ))}
//     </div>
//   );
// };
// 
// // Input field component
// const FormField = ({ label, description, children }) => (
//   <div className="space-y-2">
//     <label className="block text-sm font-medium text-slate-200">{label}</label>
//     {description && <p className="text-xs text-slate-400">{description}</p>}
//     {children}
//   </div>
// );
// 
// // Number input with suffix
// const NumberInput = ({ value, onChange, suffix, min = 0, max = 100 }) => (
//   <div className="flex items-center gap-2">
//     <input
//       type="number"
//       value={value}
//       onChange={(e) => onChange(parseInt(e.target.value) || 0)}
//       min={min}
//       max={max}
//       className="w-20 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-100 focus:outline-none focus:ring-2 focus:ring-emerald-500"
//     />
//     <span className="text-sm text-slate-400">{suffix}</span>
//   </div>
// );
// 
// // Node type selector
// const NodeTypeSelect = ({ value, onChange }) => {
//   const types = [
//     { value: 'in_house', label: 'In-House', icon: Building2 },
//     { value: 'third_party_3pl', label: '3PL', icon: Truck },
//     { value: 'shopify_fulfillment', label: 'Shopify Fulfillment', icon: Package },
//   ];
// 
//   return (
//     <div className="flex gap-2">
//       {types.map(({ value: v, label, icon: Icon }) => (
//         <button
//           key={v}
//           type="button"
//           onClick={() => onChange(v)}
//           className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
//             value === v
//               ? 'bg-emerald-600 text-white'
//               : 'bg-slate-800 text-slate-300 hover:bg-slate-700'
//           }`}
//         >
//           <Icon className="w-4 h-4" />
//           {label}
//         </button>
//       ))}
//     </div>
//   );
// };
// 
// // Main Wizard Component
// export default function PromiseWizardPage() {
//   const navigate = useNavigate();
//   const [currentStep, setCurrentStep] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
// 
//   // Policy state
//   const [policy, setPolicy] = useState({
//     timezone: 'America/Los_Angeles',
//     remorse_window_minutes: 30,
//     standard_min_days: 5,
//     standard_max_days: 7,
//     expedited_min_days: 2,
//     expedited_max_days: 3,
//     overnight_min_days: 1,
//     overnight_max_days: 1,
//     count_business_days: true,
//     track_calendar_expectation: true,
//     alert_threshold_late_risk: 15,
//     alert_threshold_pcr: 5,
//     alert_threshold_backorder: 20,
//   });
// 
//   // Nodes state
//   const [nodes, setNodes] = useState([
//     { node_id: 'node-1', name: 'Primary Warehouse', node_type: 'in_house', pick_pack_sla_hours: 24, active: true },
//   ]);
// 
//   // Shopify locations (fetched)
//   const [shopifyLocations, setShopifyLocations] = useState([]);
// 
//   const steps = [
//     { id: 'policy', title: 'Promise Policy', icon: Clock },
//     { id: 'nodes', title: 'Node Mapping', icon: Layers },
//     { id: 'cancellation', title: 'Cancellation Window', icon: AlertTriangle },
//     { id: 'alerts', title: 'Alerts', icon: Bell },
//   ];
// 
//   // Fetch existing configuration
//   useEffect(() => {
//     const fetchConfig = async () => {
//       try {
//         // Fetch promise policy
//         const policyRes = await fetch(`${BACKEND_URL}/api/margin-guard/settings/promise-policy`);
//         if (policyRes.ok) {
//           const data = await policyRes.json();
//           if (data.brand_id) {
//             setPolicy(prev => ({ ...prev, ...data }));
//           }
//         }
// 
//         // Fetch nodes
//         const nodesRes = await fetch(`${BACKEND_URL}/api/margin-guard/settings/nodes`);
//         if (nodesRes.ok) {
//           const data = await nodesRes.json();
//           if (data.nodes && data.nodes.length > 0) {
//             setNodes(data.nodes);
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching config:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
// 
//     fetchConfig();
//   }, []);
// 
//   // Save policy
//   const savePolicy = async () => {
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/settings/promise-policy`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ ...policy, brand_id: 'demo-brand' }),
//       });
// 
//       if (!res.ok) throw new Error('Failed to save policy');
//       return true;
//     } catch (error) {
//       console.error('Error saving policy:', error);
//       return false;
//     }
//   };
// 
//   // Save nodes
//   const saveNodes = async () => {
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/settings/nodes?brand_id=demo-brand`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(nodes),
//       });
// 
//       if (!res.ok) throw new Error('Failed to save nodes');
//       return true;
//     } catch (error) {
//       console.error('Error saving nodes:', error);
//       return false;
//     }
//   };
// 
//   // Handle next step
//   const handleNext = async () => {
//     setSaving(true);
// 
//     // Save current step data
//     if (currentStep === 0 || currentStep === 2 || currentStep === 3) {
//       const success = await savePolicy();
//       if (!success) {
//         toast.error('Failed to save configuration');
//         setSaving(false);
//         return;
//       }
//     }
// 
//     if (currentStep === 1) {
//       const success = await saveNodes();
//       if (!success) {
//         toast.error('Failed to save node configuration');
//         setSaving(false);
//         return;
//       }
//     }
// 
//     setSaving(false);
// 
//     if (currentStep < steps.length - 1) {
//       setCurrentStep(currentStep + 1);
//     } else {
//       // Completed - redirect to dashboard
//       toast.success('Margin Guard configured successfully!');
//       navigate('/dashboard/margin-guard');
//     }
//   };
// 
//   // Handle back
//   const handleBack = () => {
//     if (currentStep > 0) {
//       setCurrentStep(currentStep - 1);
//     } else {
//       navigate('/dashboard/margin-guard');
//     }
//   };
// 
//   // Add new node
//   const addNode = () => {
//     setNodes([
//       ...nodes,
//       {
//         node_id: `node-${nodes.length + 1}`,
//         name: `New Location ${nodes.length + 1}`,
//         node_type: 'third_party_3pl',
//         pick_pack_sla_hours: 24,
//         active: true,
//       },
//     ]);
//   };
// 
//   // Update node
//   const updateNode = (index, updates) => {
//     const newNodes = [...nodes];
//     newNodes[index] = { ...newNodes[index], ...updates };
//     setNodes(newNodes);
//   };
// 
//   // Remove node
//   const removeNode = (index) => {
//     if (nodes.length > 1) {
//       setNodes(nodes.filter((_, i) => i !== index));
//     }
//   };
// 
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-slate-950 flex items-center justify-center">
//         <div className="text-center">
//           <RefreshCw className="w-8 h-8 text-emerald-500 animate-spin mx-auto mb-4" />
//           <p className="text-slate-400">Loading configuration...</p>
//         </div>
//       </div>
//     );
//   }
// 
//   return (
//     <div className="min-h-screen bg-slate-950 px-6 py-8">
//       <div className="max-w-3xl mx-auto">
//         {/* Header */}
//         <div className="flex items-center gap-4 mb-8">
//           <button
//             onClick={handleBack}
//             className="p-2 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white transition-colors"
//           >
//             <ChevronLeft className="w-5 h-5" />
//           </button>
//           <div>
//             <h1 className="text-2xl font-bold text-slate-100 flex items-center gap-2">
//               <Settings className="w-6 h-6 text-emerald-500" />
//               Promise Wizard
//             </h1>
//             <p className="text-sm text-slate-400">Configure your Margin Guard settings</p>
//           </div>
//         </div>
// 
//         {/* Step Indicator */}
//         <StepIndicator steps={steps} currentStep={currentStep} />
// 
//         {/* Step Content */}
//         <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6 mb-6">
//           {/* Step 1: Promise Policy */}
//           {currentStep === 0 && (
//             <div className="space-y-6">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="p-2 rounded-lg bg-emerald-600/20">
//                   <Clock className="w-5 h-5 text-emerald-400" />
//                 </div>
//                 <div>
//                   <h2 className="text-lg font-semibold text-slate-100">Promise Policy</h2>
//                   <p className="text-sm text-slate-400">
//                     Define your delivery promise windows. We score operations using business days, and track CSAT risk using calendar days.
//                   </p>
//                 </div>
//               </div>
// 
//               <div className="grid gap-6">
//                 <div className="p-4 rounded-xl bg-slate-800/50 border border-slate-700">
//                   <h3 className="font-medium text-slate-200 mb-4">Standard Shipping</h3>
//                   <div className="grid grid-cols-2 gap-4">
//                     <FormField label="Minimum Days">
//                       <NumberInput
//                         value={policy.standard_min_days}
//                         onChange={(v) => setPolicy({ ...policy, standard_min_days: v })}
//                         suffix="business days"
//                         min={1}
//                         max={30}
//                       />
//                     </FormField>
//                     <FormField label="Maximum Days">
//                       <NumberInput
//                         value={policy.standard_max_days}
//                         onChange={(v) => setPolicy({ ...policy, standard_max_days: v })}
//                         suffix="business days"
//                         min={1}
//                         max={30}
//                       />
//                     </FormField>
//                   </div>
//                 </div>
// 
//                 <div className="p-4 rounded-xl bg-slate-800/50 border border-slate-700">
//                   <h3 className="font-medium text-slate-200 mb-4">Expedited Shipping</h3>
//                   <div className="grid grid-cols-2 gap-4">
//                     <FormField label="Minimum Days">
//                       <NumberInput
//                         value={policy.expedited_min_days}
//                         onChange={(v) => setPolicy({ ...policy, expedited_min_days: v })}
//                         suffix="business days"
//                         min={1}
//                         max={14}
//                       />
//                     </FormField>
//                     <FormField label="Maximum Days">
//                       <NumberInput
//                         value={policy.expedited_max_days}
//                         onChange={(v) => setPolicy({ ...policy, expedited_max_days: v })}
//                         suffix="business days"
//                         min={1}
//                         max={14}
//                       />
//                     </FormField>
//                   </div>
//                 </div>
// 
//                 <div className="p-4 rounded-xl bg-slate-800/50 border border-slate-700">
//                   <h3 className="font-medium text-slate-200 mb-4">Overnight Shipping</h3>
//                   <div className="grid grid-cols-2 gap-4">
//                     <FormField label="Minimum Days">
//                       <NumberInput
//                         value={policy.overnight_min_days}
//                         onChange={(v) => setPolicy({ ...policy, overnight_min_days: v })}
//                         suffix="business days"
//                         min={1}
//                         max={3}
//                       />
//                     </FormField>
//                     <FormField label="Maximum Days">
//                       <NumberInput
//                         value={policy.overnight_max_days}
//                         onChange={(v) => setPolicy({ ...policy, overnight_max_days: v })}
//                         suffix="business days"
//                         min={1}
//                         max={3}
//                       />
//                     </FormField>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
// 
//           {/* Step 2: Node Mapping */}
//           {currentStep === 1 && (
//             <div className="space-y-6">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="p-2 rounded-lg bg-blue-600/20">
//                   <Layers className="w-5 h-5 text-blue-400" />
//                 </div>
//                 <div>
//                   <h2 className="text-lg font-semibold text-slate-100">Node Mapping</h2>
//                   <p className="text-sm text-slate-400">
//                     Map your fulfillment locations to node types for accurate breakdowns.
//                   </p>
//                 </div>
//               </div>
// 
//               <div className="space-y-4">
//                 {nodes.map((node, index) => (
//                   <div
//                     key={node.node_id}
//                     className="p-4 rounded-xl bg-slate-800/50 border border-slate-700"
//                   >
//                     <div className="flex items-start justify-between mb-4">
//                       <FormField label="Location Name">
//                         <input
//                           type="text"
//                           value={node.name}
//                           onChange={(e) => updateNode(index, { name: e.target.value })}
//                           className="w-64 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-100 focus:outline-none focus:ring-2 focus:ring-emerald-500"
//                           placeholder="e.g., West Coast 3PL"
//                         />
//                       </FormField>
//                       {nodes.length > 1 && (
//                         <button
//                           onClick={() => removeNode(index)}
//                           className="text-sm text-rose-400 hover:text-rose-300"
//                         >
//                           Remove
//                         </button>
//                       )}
//                     </div>
// 
//                     <FormField label="Node Type" description="How is this location operated?">
//                       <NodeTypeSelect
//                         value={node.node_type}
//                         onChange={(v) => updateNode(index, { node_type: v })}
//                       />
//                     </FormField>
// 
//                     <div className="mt-4">
//                       <FormField label="Pick/Pack SLA" description="Target time from order to shipment ready">
//                         <NumberInput
//                           value={node.pick_pack_sla_hours}
//                           onChange={(v) => updateNode(index, { pick_pack_sla_hours: v })}
//                           suffix="hours"
//                           min={1}
//                           max={168}
//                         />
//                       </FormField>
//                     </div>
//                   </div>
//                 ))}
// 
//                 <button
//                   onClick={addNode}
//                   className="w-full py-3 border-2 border-dashed border-slate-700 rounded-xl text-slate-400 hover:text-slate-200 hover:border-slate-600 transition-colors"
//                 >
//                   + Add Another Location
//                 </button>
//               </div>
//             </div>
//           )}
// 
//           {/* Step 3: Cancellation Window */}
//           {currentStep === 2 && (
//             <div className="space-y-6">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="p-2 rounded-lg bg-amber-600/20">
//                   <AlertTriangle className="w-5 h-5 text-amber-400" />
//                 </div>
//                 <div>
//                   <h2 className="text-lg font-semibold text-slate-100">Cancellation Window</h2>
//                   <p className="text-sm text-slate-400">
//                     Set your buyer remorse window. Cancellations within this window are tracked but not penalized in your PCR score.
//                   </p>
//                 </div>
//               </div>
// 
//               <div className="p-6 rounded-xl bg-slate-800/50 border border-slate-700">
//                 <FormField
//                   label="Buyer Remorse Window"
//                   description="Cancellations within this time are considered 'change of mind' and excluded from PCR calculation"
//                 >
//                   <NumberInput
//                     value={policy.remorse_window_minutes}
//                     onChange={(v) => setPolicy({ ...policy, remorse_window_minutes: v })}
//                     suffix="minutes"
//                     min={0}
//                     max={1440}
//                   />
//                 </FormField>
// 
//                 <div className="mt-6 p-4 rounded-lg bg-slate-900/50">
//                   <h4 className="text-sm font-medium text-slate-300 mb-2">How it works</h4>
//                   <ul className="text-sm text-slate-400 space-y-1">
//                     <li>• Cancels ≤ {policy.remorse_window_minutes} minutes = <span className="text-slate-300">"Buyer Remorse"</span> (tracked, not penalized)</li>
//                     <li>• Cancels {'>'} {policy.remorse_window_minutes} minutes = <span className="text-amber-400">Eligible for PCR classification</span></li>
//                     <li>• PCR drivers are classified as: inventory, fulfillment latency, transit risk, or unknown</li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           )}
// 
//           {/* Step 4: Alerts */}
//           {currentStep === 3 && (
//             <div className="space-y-6">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="p-2 rounded-lg bg-purple-600/20">
//                   <Bell className="w-5 h-5 text-purple-400" />
//                 </div>
//                 <div>
//                   <h2 className="text-lg font-semibold text-slate-100">Alert Thresholds</h2>
//                   <p className="text-sm text-slate-400">
//                     Set thresholds for when alerts are triggered. Alerts appear in your Fix List and can be sent to Slack.
//                   </p>
//                 </div>
//               </div>
// 
//               <div className="space-y-4">
//                 <div className="p-4 rounded-xl bg-slate-800/50 border border-slate-700">
//                   <FormField
//                     label="Late Risk Alert"
//                     description="Trigger when this % of orders are at risk of missing deadline"
//                   >
//                     <NumberInput
//                       value={policy.alert_threshold_late_risk}
//                       onChange={(v) => setPolicy({ ...policy, alert_threshold_late_risk: v })}
//                       suffix="% of orders"
//                       min={1}
//                       max={100}
//                     />
//                   </FormField>
//                 </div>
// 
//                 <div className="p-4 rounded-xl bg-slate-800/50 border border-slate-700">
//                   <FormField
//                     label="PCR Alert"
//                     description="Trigger when preventable cancellation rate exceeds threshold"
//                   >
//                     <NumberInput
//                       value={policy.alert_threshold_pcr}
//                       onChange={(v) => setPolicy({ ...policy, alert_threshold_pcr: v })}
//                       suffix="% rate"
//                       min={1}
//                       max={50}
//                     />
//                   </FormField>
//                 </div>
// 
//                 <div className="p-4 rounded-xl bg-slate-800/50 border border-slate-700">
//                   <FormField
//                     label="Backorder Risk Alert"
//                     description="Trigger when this % of orders are aging without fulfillment"
//                   >
//                     <NumberInput
//                       value={policy.alert_threshold_backorder}
//                       onChange={(v) => setPolicy({ ...policy, alert_threshold_backorder: v })}
//                       suffix="% of orders"
//                       min={1}
//                       max={100}
//                     />
//                   </FormField>
//                 </div>
//               </div>
// 
//               <div className="p-4 rounded-xl bg-emerald-900/20 border border-emerald-800/50">
//                 <div className="flex items-center gap-2 text-emerald-400 mb-2">
//                   <Check className="w-4 h-4" />
//                   <span className="font-medium">You're all set!</span>
//                 </div>
//                 <p className="text-sm text-slate-400">
//                   Click "Complete Setup" to save your configuration and start using Margin Guard.
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>
// 
//         {/* Navigation Buttons */}
//         <div className="flex items-center justify-between">
//           <button
//             onClick={handleBack}
//             className="px-6 py-2 border border-slate-700 bg-slate-800 text-slate-200 rounded-lg font-medium hover:bg-slate-700 transition-colors"
//           >
//             Back
//           </button>
// 
//           <button
//             onClick={handleNext}
//             disabled={saving}
//             className="px-6 py-2 bg-emerald-600 text-white rounded-lg font-semibold hover:bg-emerald-700 transition-colors flex items-center gap-2 disabled:opacity-50"
//           >
//             {saving ? (
//               <>
//                 <RefreshCw className="w-4 h-4 animate-spin" />
//                 Saving...
//               </>
//             ) : currentStep === steps.length - 1 ? (
//               <>
//                 <Check className="w-4 h-4" />
//                 Complete Setup
//               </>
//             ) : (
//               <>
//                 Next
//                 <ChevronRight className="w-4 h-4" />
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }
// END ORIGINAL SOURCE

export default function HeldPromiseWizardPage() { return <MarginGuardHeld/>; }
